module.exports = __webpack_public_path__ + "static/media/enterprise_gallery.b0d19b2a.png";